import React from 'react';
import StandardModal from '@/components/commons/StandardModal';
import ThumbsDownSolid from '@/components/commons/icons/ThumbsDownSolid';
import ThumbsUpSolid from '@/components/commons/icons/ThumbsUpSolid';
import ExclamationMarkSolid from '@/components/commons/icons/ExclamationMarkSolid';

const warningModalClassnames = {
    modal: ' z-[10000] overflow-hidden min-w-[450px] max-w-[450px] min-h-[300px] mt-[30vh] bg-transparent shadow-none rounded-lg p-0',
    closeButton: 'hidden',
};

const warningModalInfo = [
    {
        title: 'Are you sure you want to quit?',
        subtitle: 'Closing the game now will not affect the questions you’ve already answered. We will remember your choices and apply them to your contacts.',
        buttons: [
            {
                title: 'Quit the game',
                icon: <ThumbsDownSolid className="w-4 h-4 text-cleanSlate" />,
                buttonClassName: ' border-[1px] border-cleanSlate rounded-lg bg-cirrusWhite flex items-center justify-center py-2 px-0 mr-2 ',
                titleClassname: 'font-medium min-w-[65px]',
                key: 'quit-game-button',
            },
            {
                title: 'Keep playing',
                icon: <ThumbsUpSolid className="w-4 h-4 text-white" />,
                buttonClassName: 'rounded-lg bg-green-400 flex items-center justify-center py-2 px-2 mr-2 ',
                titleClassname: 'font-medium min-w-[65px] text-cirrusWhite',
                key: 'keep-playing-button',
            },
        ],
    },
    {
        title: 'Something went wrong',
        subtitle: 'We’re having difficulty loading the game for you. Please refresh your browser and try again.',
        icon: <ExclamationMarkSolid className="w-5 h-5 text-cleanSlate" />,
        buttons: [
            {
                title: 'Okay',
                buttonClassName: ' border-[1px] border-cleanSlate rounded-lg bg-cirrusWhite flex items-center justify-center py-2 px-0 mr-2 ',
                titleClassname: 'font-medium min-w-[65px]',
                key: 'okay-button',
            },
        ],
    },
    {
        title: 'Something went wrong',
        subtitle: 'We’re having difficulty saving your answers. Please refresh your browser and try again.',
        icon: <ExclamationMarkSolid className="w-5 h-5 text-cleanSlate" />,
        buttons: [
            {
                title: 'Okay',
                buttonClassName: ' border-[1px] border-cleanSlate rounded-lg bg-cirrusWhite flex items-center justify-center py-2 px-0 mr-2 ',
                titleClassname: 'font-medium min-w-[65px]',
                key: 'okay-button',
            },
        ],
    },
];

function ClosingModal({
    isModalOpen,
    showClosingModal,
    showWarningModal,
    closeModal,
    modalType,
}) {
    const modalInfo = warningModalInfo[modalType];
    return (
        <div className="relative flex items-center justify-center">
            {showWarningModal && (
                <StandardModal
                    open={isModalOpen}
                    onClose={closeModal}
                    headline={null}
                    classNames={warningModalClassnames}
                    styles={null}
                >
                    <div className="relative flex flex-col w-full bg-cirrusWhite rounded-xl">
                        <div className="p-6 flex items-center border-b-[1px]">
                            {modalInfo.icon && (
                                <div className="mr-2 w-5">
                                    {modalInfo.icon}
                                </div>
                            )}
                            <div className="pt-1 text-[18px] font-semibold ">
                                {modalInfo.title}
                            </div>
                        </div>
                        <div className="p-6 flex items-center justify-center">
                            {modalInfo.subtitle}
                        </div>
                        <div className="flex items-center justify-around p-6">
                            {modalInfo.buttons?.map((button, i) => (
                                <button
                                    type="button"
                                    data-tooltip-id="tip"
                                    title={button.title}
                                    aria-label={button.title}
                                    key={button.key}
                                    onClick={i === 0
                                        ? () => closeModal()
                                        : () => showClosingModal()}
                                    className={button.buttonClassName}
                                >
                                    <div className="flex items-center justify-center px-4 py-1">
                                        {button.icon && (
                                            <div className="mr-2 w-4">
                                                {button.icon}
                                            </div>
                                        )}
                                        <p className={button.titleClassname}>{button.title}</p>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                </StandardModal>
            )}
        </div>
    );
}

export default ClosingModal;
